import { useEffect, useState } from 'react'
import { BooksitoutServer } from '../../../config/BooksitoutServer'
import BookAuthorResponse from './BookAuthorResponse'

const useBookAuthor = (urlName: string | null) => {
	const [data, setData] = useState<BookAuthorResponse | null>(null)
	const [isLoading, setIsLoading] = useState(true)
	const [isError, setIsError] = useState(false)

	useEffect(() => {
		if (urlName == null) return

		setIsLoading(true)
		BooksitoutServer
			.get(`/v1/book-author/${urlName}`)
			.then(res => setData(res.data))
			.catch(() => setIsError(true))
			.finally(() => setIsLoading(false))
	}, [urlName])

	return [data, isLoading, isError] as const
}

export default useBookAuthor
